import { css } from '@emotion/react'

export const CodeBlockStyle = css`


    .diffNewLine {
        color: #22863a;
        background-color: #f0fff4;
    }
  
    .diffRemoveLine {
        color: red;
        background-color: #ffcccc;
    }

`


export const SimpleCodeBlockStyle = css`
    padding: 2px 4px;
    color: #1f1f1f;
    background-color: #f0f0f0;
    border-radius: 4px;
`



